<template>
  <v-dialog v-model="dialogModel" max-width="500" persistent>
    <v-card class="rounded-xl">
      <v-card-title class="d-flex align-center pb-0">
        <v-icon color="#EE2526" class="mr-2">mdi-close-circle-outline</v-icon>
        <span class="dialog-title">ปฏิเสธไรเดอร์</span>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="mx-4 mt-2" />

      <v-card-text class="pt-4">
        <div v-if="rider" class="rider-info mb-4">
          <div class="d-flex align-center mb-2">
            <v-icon small class="mr-2">mdi-account</v-icon>
            <span class="font-weight-medium">{{ riderDisplayName }}</span>
          </div>
          <div class="d-flex align-center">
            <v-icon small class="mr-2">mdi-email-outline</v-icon>
            <span>{{ rider.email || '-' }}</span>
          </div>
        </div>

        <div class="section-title mb-2">เหตุผลในการปฏิเสธ</div>
        <v-textarea
          v-model="rejectReason"
          outlined
          dense
          rows="3"
          placeholder="ระบุเหตุผล (ไม่บังคับ)"
          class="rounded-lg"
          hide-details="auto"
        />
      </v-card-text>

      <v-divider class="mx-4" />

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text class="rounded-lg" @click="close">ยกเลิก</v-btn>
        <v-btn
          color="#EE2526"
          dark
          class="rounded-lg elevation-0 px-6"
          :loading="saving"
          @click="confirm"
        >
          <v-icon left small>mdi-close-circle-outline</v-icon>
          ยืนยันปฏิเสธ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RejectDialog",

  props: {
    value: Boolean,
    rider: { type: Object, default: null },
    saving: Boolean,
  },

  data() {
    return {
      rejectReason: "",
    };
  },

  computed: {
    dialogModel: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    },

    riderDisplayName() {
      if (!this.rider) return "-";
      const p = this.rider.natId_prefix || "";
      const f = this.rider.natId_firstName || "";
      const l = this.rider.natId_lastName || "";
      const parts = [p, f, l].filter(Boolean);
      return parts.length ? parts.join(" ") : this.rider.email || "-";
    },
  },

  watch: {
    value(open) {
      if (open) {
        this.rejectReason = "";
      }
    },
  },

  methods: {
    confirm() {
      this.$emit("confirm", { rejectReason: this.rejectReason });
    },

    close() {
      this.dialogModel = false;
    },
  },
};
</script>

<style scoped>
.dialog-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2a39;
}
.rider-info {
  background: #f9fafb;
  border-radius: 8px;
  padding: 12px 16px;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2a39;
}
</style>
